import styled from 'styled-components';

export const MultiplierInput = styled.input.attrs({
  className:
    'w-14 rounded-lg border border-border bg-muted px-2 py-1 text-center text-card-foreground',
})``;

export const DurationInput = styled.input.attrs({
  className: 'w-20 rounded-lg border border-input bg-white px-2 py-1 text-center',
})``;
